import type { Site } from '../Site';

export const PracticalBoatOwner: Site = {
  id: 'pbo',
  logo: 'pbo.png',
  label: 'Practical Boat Owner',
  analyticsName: 'pbo',
  hostname: 'pbo.co.uk',
  platform: 'ti',
  selector: '#content a',
};
